import { call, put } from 'redux-saga/effects';

import { getMessages } from '@api/messages';
import { noop } from '@constants/general';
import { MESSAGE_STATUS } from '@constants/messages';
import { unreadMessageCountSuccessAction } from '@store/user/user.actions';

export const handleUnreadMessagesRequestSaga = function* () {
  try {
    const result = yield call(
      getMessages,
      { limit: 1, status: MESSAGE_STATUS.UN_READ },
      { onFailure: noop, axiosOptions: { skipAuthRefresh: true } } // Do nothing on failure. We don't want polling to redirect users to login
    );
    const { count } = result;
    yield put(unreadMessageCountSuccessAction(count));
  } catch (error) {
    // Do nothing
  }
};
